import React, { useState, useEffect } from 'react';
import Stories from './Stories';
import storiesService from '../services/storiesService';
// Import as a regular path
import storiesIcon from '../images/stories-icon.svg';

const StoriesButton = () => {
  const [isStoriesOpen, setIsStoriesOpen] = useState(false);
  const [hasUnreadStories, setHasUnreadStories] = useState(false);

  // Check for unread stories on component mount
  useEffect(() => {
    const checkUnreadStories = async () => {
      const hasUnviewed = await storiesService.hasUnviewedStories();
      setHasUnreadStories(hasUnviewed);
    };
    
    checkUnreadStories();
    
    // Check for new stories every 5 minutes
    const interval = setInterval(checkUnreadStories, 5 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, []);

  const openStories = () => {
    setIsStoriesOpen(true);
    // Mark all stories as viewed when opening
    storiesService.markAllStoriesAsViewed();
    setHasUnreadStories(false);
  };

  const closeStories = () => {
    setIsStoriesOpen(false);
  };

  return (
    <>
      <div className="stories-button-container" style={{ position: 'relative' }}>
        <img 
          src={storiesIcon} 
          alt="Stories"
          className={`stories-book-icon ${hasUnreadStories ? 'has-unread' : ''}`} 
          onClick={openStories}
          style={{ 
            width: '24px', 
            height: '24px',
            filter: hasUnreadStories ? 'invert(83%) sepia(54%) saturate(4264%) hue-rotate(0deg) brightness(110%) contrast(106%)' : 'brightness(0) invert(1)'
          }}
        />
        {hasUnreadStories && <span className="stories-notification-dot"></span>}
      </div>
      <Stories isOpen={isStoriesOpen} onClose={closeStories} />
    </>
  );
};

export default StoriesButton; 